import React from 'react';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormattedMessage } from 'i18n';
import flexbox from 'styles/utils/flexbox';

import { mediaQueries } from 'styles/utils/mediaQueries';
import truncate from 'styles/utils/truncate';

function HighlightsComponent({ highlights, airlineWhitelabel }) {
  const sections = [highlights.slice(0, 3), highlights.slice(3, 5), highlights.slice(3)];

  return (
    <Root airlineWhitelabel={airlineWhitelabel}>
      <Margin top={{ tiny: 0, tablet: 3 }} bottom={4} style={{ height: '100%', flex: 1 }}>
        <FontAwesomeIcon icon='check' size='5x' className='icon-smallScreens' />
        <ul>
          {sections[0].map(({ id, defaultMessage }) => (
            <li key={`0-${id}`}>
              <FontAwesomeIcon icon='check' />
              <FormattedMessage id={id} description={defaultMessage} defaultMessage={defaultMessage} />
            </li>
          ))}
          {sections[1].map(({ id, defaultMessage }) => (
            <li key={`1-${id}`} className='li-smallScreens'>
              <FontAwesomeIcon icon='check' />
              <FormattedMessage id={id} description={defaultMessage} defaultMessage={defaultMessage} />
            </li>
          ))}
        </ul>
      </Margin>
      <Margin top={{ tiny: 0, tablet: 3 }} bottom={4} style={{ height: '100%', width: '50%' }} className='ul-desktop'>
        <ul>
          {sections[2].map(({ id, defaultMessage }) => (
            <li key={`2-${id}`}>
              <FontAwesomeIcon icon='check' />
              <FormattedMessage id={id} description={defaultMessage} defaultMessage={defaultMessage} />
            </li>
          ))}
        </ul>
      </Margin>
    </Root>
  );
}

export default HighlightsComponent;

const Root = styled.div`
  ${flexbox({
    justifyContent: 'space-around',
  })}

  div > ul li {
    font-size: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? '17px' : '20px')};
    ${mediaQueries.fromAndAbove.desktop`
      ${truncate()}
    `}
  }
`;
